export default __webpack_public_path__ + "static/media/normal-quiz.12ad3893.jpg";